import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { AdType } from './desk-ad-type';

@Component({
  selector: 'app-desk-ad',
  templateUrl: './desk-ad.component.html',
  styleUrls: ['./desk-ad.component.scss']
})
export class DeskAdComponent implements OnInit {

  @Input() adType: AdType = null;

  adDataMap: { [key in AdType]: { class: string, dataKey: string } } = {
    [AdType.RON_Flex_Sky]: { class: '27ff66ea', dataKey: 'f42f55ba01ba071a37f359d4c91557d5' },
    [AdType.RON_Flex_300w]: { class: '27ff66ea', dataKey: '755aef3f6e81b5a1d39398a3c4fc19f8' },
    [AdType.RON_Flex_Leader]: { class: '27ff66ea', dataKey: '14f3a724b0ce0333187ffdbfff48e908' },
    [AdType.RON_Footerboard]: { class: '27ff66ea', dataKey: 'ea89a48d96b214c8324829cbabb824e6' },
    [AdType.RON_Interstitial]: { class: '27ff66ea', dataKey: '7da679e034c666f33baa8c27b0eb1256' },
    [AdType.RON_Reveal]: { class: '27ff66ea', dataKey: 'f4f48b42abdf1a0a00bbe663a3698551' },
  };

  get adData() {
    return this.adDataMap[this.adType] || { class: '', dataKey: '' };
  }

  constructor() { }

  ngOnInit(): void {
    this.loadScript('https://adcdn.nightlife.net/afe755b2.js');
  }

  loadScript(src: string): void {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
  }
}
